export default {
  title: '登入',
  welcomeBack: '歡迎!',
  email: '電郵地址',
  password: '密碼',
  login: '登入',
  forgotYourPassword: '忘記密碼?',
  getStarted: '未有戶口? 按此開始',
}
